import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [TranslatePipe],
  selector: 'monitor-ui-configuration-table',
  styleUrls: ['./configuration-table.component.scss'],
  templateUrl: './configuration-table.component.html',
})
export class ConfigurationTableComponent {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  // @Input() site: SiteDto;
  // dataSource: MatTableDataSource<SiteConfigurationsDto>;
  // displayedColumns = ['status', 'name', 'lastUpdatedDate', 'actions'];
  //
  // constructor() {}
  //
  // // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // ngOnChanges(changes: SimpleChanges): void {
  //   this.configurations = this.configurations.sort(
  //     (firstDate: SiteConfigurationsDto, secondDate: SiteConfigurationsDto) => {
  //       return new Date(secondDate.lastUpdatedDate).valueOf() - new Date(firstDate.lastUpdatedDate).valueOf();
  //     },
  //   );
  //   this.initDataSource(this.configurations);
  // }
  //
  // sortData(sort: Sort): void {
  //   let data = this.configurations.slice();
  //   if (!sort.active || sort.direction === '') {
  //     this.initDataSource(this.configurations);
  //     return;
  //   }
  //
  //   data = data.sort((configuration1: SiteConfigurationsDto, configuration2: SiteConfigurationsDto) => {
  //     const isAscending = sort.direction === 'asc';
  //     switch (sort.active) {
  //       case 'type':
  //         return this.compare(configuration1.type ?? '', configuration2.type, isAscending);
  //       case 'name':
  //         return this.compare(configuration1.displayLabel, configuration2.displayLabel, isAscending);
  //       case 'oem':
  //         return this.compare(configuration1.oem, configuration2.oem, isAscending);
  //       case 'rackBatteries':
  //         return this.compare(configuration1.rack, configuration2.rack, isAscending);
  //       case 'powerCapacity':
  //         return this.compare(configuration1.powerCapacity, configuration2.powerCapacity, isAscending);
  //       case 'energyCapacity':
  //         return this.compare(configuration1.energyCapacity, configuration2.energyCapacity, isAscending);
  //       case 'lastUpdatedDate':
  //         return this.compareDate(configuration1.lastUpdatedDate, configuration2.lastUpdatedDate, isAscending);
  //       default:
  //         return 0;
  //     }
  //   });
  //
  //   this.initDataSource(data);
  // }
  //
  // compare(a: number | string, b: number | string, isAsc: boolean): number {
  //   return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  // }
  //
  // compareDate(a: string, b: string, isAsc: boolean): number {
  //   const aa = new Date(a);
  //   const bb = new Date(b);
  //   return (aa < bb ? -1 : 1) * (isAsc ? 1 : -1);
  // }
  //
  // private initDataSource(configurations: SiteConfigurationsDto[]): void {
  //   if (!configurations?.length) {
  //     return;
  //   }
  //   const initTable = (): void => {
  //     this.dataSource = new MatTableDataSource<SiteConfigurationsDto>(configurations);
  //     this.dataSource.paginator = this.paginator;
  //     this.dataSource.sort = this.sort;
  //   };
  //   setTimeout(initTable);
  // }
}
